import useSWR from 'swr'

import { FetchError } from '../../../data/fetchError'
import { FetchResponse } from '../../../data/fetchResponse'
import { FetchResult } from '../../../data/fetchResult'
import { fetchJson } from '../../../data/fetchers'
import { OrderResponse } from '../../../data/models'
import { WebEdiDto } from '../../../data/models'
import { OrderResponseItem } from '../../../data/models'
import { Constants } from '../../../utils/constants'
import { useConfigContext } from '../../ui-config'

// Warning pulling (refreshInterval) causes high costs in Azure!
// This was activated to show the user current data to test it
// but this needs to be replaced with optimistic UI with SignalR in the future,
// see ticket AN05873-230.

// get all orders
export function useOrders(): FetchResult<WebEdiDto<OrderResponse>[]> {
  const { pollingConfig } = useConfigContext()
  const { data, error, isLoading, mutate } = useSWR<
    FetchResponse<WebEdiDto<OrderResponse>[]>,
    FetchError
  >(`/OrderResponses`, fetchJson<WebEdiDto<OrderResponse>[]>, {
    refreshInterval: pollingConfig.intervalInSeconds * 1000,
  })

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
  }
}

// get one order
export function useOrder(
  orderResponseId: string,
): FetchResult<WebEdiDto<OrderResponse>> {
  const { data, error, isLoading, mutate } = useSWR<
    FetchResponse<WebEdiDto<OrderResponse>>,
    FetchError
  >(`/OrderResponses/${orderResponseId}`, fetchJson<WebEdiDto<OrderResponse>>)

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
  }
}

// get all items
export function useOrderItems(
  orderResponseId: string,
): FetchResult<OrderResponseItem[]> {
  const { data, error, isLoading, mutate } = useSWR<
    FetchResponse<OrderResponseItem[]>,
    FetchError
  >(`/OrderResponses/${orderResponseId}/Items`, fetchJson<OrderResponseItem[]>)

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
  }
}

// get one item
export function useOrderItem(
  orderResponseId: string,
  itemId: string,
): FetchResult<OrderResponseItem> {
  const { data, error, isLoading, mutate } = useSWR<
    FetchResponse<OrderResponseItem>,
    FetchError
  >(
    `/OrderResponses/${orderResponseId}/Items/${itemId}`,
    fetchJson<OrderResponseItem>,
  )

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
  }
}
